import { render, staticRenderFns } from "./TermsOfService.vue?vue&type=template&id=0c43361e&scoped=true&"
var script = {}
import style0 from "./TermsOfService.vue?vue&type=style&index=0&id=0c43361e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c43361e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
